import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { getThemeColor, setThemeColor } from './app/utils/util';

export const getBaseUrl = () => document.getElementsByTagName('base')[0].href;

const providers = [{ provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }];

if (environment.production) {
  // enableProdMode();
}

// platformBrowserDynamic(providers)
//   .bootstrapModule(AppModule)
//   .catch((err) => console.log(err));

const color =
  environment.isMultiColorActive || environment.isDarkSwitchActive ? getThemeColor() : environment.defaultColor;

import('./assets/css/sass/themes/vien.' + color + '.scss')
  .then((x) => {
    setThemeColor(color);
    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch((err) => console.error(err));
  })
  .catch(() => {
    setThemeColor(null);
    window.location.reload();
  });

// prevent scrolling of main content in case sidebar is scrolled to end
setTimeout(() => {
  const body = document.getElementsByTagName('body')[0];
  const sidebar = document.getElementsByTagName('app-sidebar')[0];
  const shell = document.getElementById('dashboard-shell');
  if (sidebar) {
    sidebar.addEventListener('mouseover', (event) => {
      body.style.overflow = 'hidden';
    }, false);
  }

  if (shell) {
    shell.addEventListener('mouseover', (event) => {
      body.style.overflow = 'auto';
    }, false);
  }
}, 3000);
